export default __webpack_public_path__ + "static/media/2.53b48962.png";